import React from "react";
import styled from "styled-components";

import imagemFundo from "../../images/imagemfundo.png";
import Globais from "../../css/Globais";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  opacity: 80%;
`;
const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
`;

const ContainerTermo = styled.div`
  width: 100%;
  height: 100%;
  max-width: 80rem;
  min-width: 15rem;
  min-height: 30rem;
  justify-self: flex-start;

  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color: #fff;
  border-radius: 30px;
  position: absolute;
  z-index: 0;
  display: grid;
  grid-template: 10% 90%/ 100%;
  justify-content: center;
  aligm-itens: center;
`;

const TextWrapper = styled.div`
  display: flex;

  justify-content: flex-start;
  margin-left: 2rem;
  margin-right: 2rem;
  overflow: auto;

  flex-direction: column;
  @media (min-width: 450px) {
    margin-left: 5rem;
    margin-right: 5rem;
  }
`;

const ContainerTitulo = styled.div`
  width: 100%;

  height: 100%;
  display: flex;
  justify-content: center;
`;

const Titulo = styled.h1`
  width: 10rem;
  text-align: center;
  align-self: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.8rem;
  width: 80%;
  margin-top: 3rem;
  @media (max-width: 300px) {
    font-size: 1.5rem;
  }
`;

const H3 = styled.h3`
  text-align: left;

  color: ${Globais.CorAzulBackGround};
  font-size: 1rem;
  @media (max-width: 300px) {
    font-size: 0.9rem;
  }
`;

const H2 = styled.h2`
  text-align: left;
  font-weight: bold;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.2rem;
`;

export default function ViewQuemSomos() {
  return (
    <Container>
      <Imagem src={imagemFundo} alt="" />
      <ContainerTermo>
        <ContainerTitulo>
          <Titulo>QUEM SOMOS</Titulo>
        </ContainerTitulo>

        <TextWrapper>
          <br />
          <br />
          <H3>
            <p>
            Nós somos a Multicotas, uma agência de viagens cadastrada e regularizada no Ministério do Turismo, especializada em multipropriedades, que tem como objetivo principal auxiliar os donos dessas multipropriedades no Brasil a administrar as suas propriedades, poupando a eles tempo, dando-lhes mais segurança e mais efetividade nas transações sejam elas trocas, aluguéis, além de outros serviços como anúncio de vendas entre outros.
            </p>
            <p>
              A aquisição de multipropriedades vem crescendo no Brasil, no
              entanto se tornou um crescimento “desorganizado”, pois falta
              comunicação e informação por parte das empresas gestoras desses
              empreendimentos. Os preços altos cobrados por essas gestoras e as
              poucas opções oferecidas desanimam e desestimulam os
              multiproprietários. E a consequência disso, é o isolamento dos
              diversos proprietários que, por não conseguir usufruir da estadia
              de outros locais ou até mesmo alugar seus períodos, deixam seus
              apartamentos desocupados o que gera grande prejuízo. Logo, vemos
              muitos querendo se desfazer de sua propriedade.
            </p>
            <p>
              É possível notar grupos de redes sociais (whatsapp, Telegram e
              Facebook) que tentam resolver esse problema, no entanto a
              quantidade de mensagens, torna o trabalho muito mais árduo. Um
              outro ponto é que a chance de você encontrar alguém que tenha
              interesses compatíveis com o que você disponibiliza é muito baixa.
              E isso afasta muitas pessoas, tornando a prática pouco efetiva e
              por conta disso acredita-se que nesses grupos tenhamos menos de 1%
              dos donos de multipropriedades do nosso país.
            </p>
            <p>
              Além disso, temos a questão da segurança. Há diversos relatos de
              golpes de pessoas que se passam por proprietários o que aumenta
              ainda mais os prejuízos.
            </p>
            <p>
              A Multicotas trará a solução para esse cenário da seguinte
              maneira:
            </p>
          </H3>
          <H2>Como funciona?</H2>
          <H3>
            <p>Cadastro </p>
            <ol>
              <li>
                <p> Deve-se efetuar um cadastro para sabermos quem é você;</p>
              </li>
              <li>
                <p>Cadastrar a propriedade;</p>
                <p>Cadastrar a propriedade;</p>
              </li>
              <li>
                <p>
                  Indicar o que deseja fazer com os períodos (trocar ou alugar);
                </p>
              </li>
              <li>
                <p>
                  Caso queira trocar, deve-se cadastrar qual o seu interesse.
                </p>
              </li>
            </ol>
            <p>
              Pronto. Não precisa fazer mais nada, você pode fazer isso para os
              próximos anos se preferir e não gastar mais nenhum tempo com isso.
              Todo o trabalho desse momento em diante será com o Multicotas.
            </p>
            <p>
              Esse pequeno procedimento é gratuito e rápido, principalmente se
              compararmos com o esforço que deve ser feito para tentar encontrar
              um outro proprietário nas redes sociais com compatibilidade de
              interesses. Com isso, acredita-se que mais proprietários irão
              aderir ao Multicotas aumentando assim a efetividade das
              transações, tomando muito pouco tempo do proprietário.
            </p>
          </H3>
          <H2>Como trazemos mais segurança?</H2>
          <H3>
            <p>
              Para gerar mais segurança aos proprietários, a Multicotas solicita
              a comprovação de propriedade. Essa comprovação é essencial para a
              conclusão das transações. Os proprietários poderão disponibilizar
              seus períodos e cadastrar seus interesses, mas a efetivação só
              será realizada entre proprietários autenticados. Esse é um
              procedimento simples que damos as instruções de como fazer após o
              cadastro.
            </p>
            <p>
              Uma outra ação de segurança é o contrato de locação que deverá ser
              assinado eletronicamente tanto pelo locador quanto pelo locatário.
            </p>
            <p>
              Além disso, todos os empreendimentos são checados antes de serem
              publicados, gerando maior confiabilidade ao realizar as
              transações.
            </p>
            <p>
              E, por fim, todas as transações bancárias só podem ser realizadas
              para as contas bancárias dos proprietários.
            </p>
          </H3>
          <H2>Como temos mais efetividade nas transações?</H2>
          <H3>
            <p>
              Nos aluguéis, além do nosso próprio site, os seus períodos são
              anunciados nas principais plataformas de aluguéis do país, como
              Expedia, Hotéis.com, Airbnb, Decolar, alguns com alcance
              internacional. Uma gestão centralizada, com a qual o proprietário
              não perderá tempo com administração do anúncio ou com respostas a
              possíveis locatários.
            </p>
            <p>
              A visibilidade desses canais e o alcance muito maior de pessoas
              aumentarão e muito a probabilidade de sucesso.
            </p>
            <p>
              Além disso, a variedade de formas de pagamentos proporciona mais
              chances de fechar o negócio.
            </p>
            <p>
              Em outra abordagem, muitas vezes, para que tenhamos uma
              efetividade nas transações (troca ou aluguel) é necessário fazer o
              que chamamos de triangulações.
            </p>
            <p>
              Exemplo: Um cenário o qual tenhamos o proprietário 1, o
              proprietário 2 e um locatário (aquele que oferece um valor em
              troca de um período).
            </p>
            <p>
              O proprietário 1, tem o período do Carnaval de um determinado
              empreendimento e determinado ano e deseja alugar esse período em
              troca de um valor.
            </p>
            <p>
              O proprietário 2, tem o período do Reveillon de um determinado
              empreendimento só que deseja o período do Carnaval do
              empreendimento oferecido pelo proprietário 1 mediante troca.
            </p>
            <p>
              O Locatário, deseja pagar um valor para se hospedar no mesmo
              empreendimento do proprietário 2, no período de Reveillon.
            </p>
            <p>
              É possível perceber que isolados eles teriam poucas chances de
              concluir suas transações, mais olhando o cenário como um todo
              podemos observar que unificando as transações o proprietário 1
              poderá ter o valor requerido, o proprietário 2 poderá se hospedar
              no período de Carnaval como desejava e o Locatário poderá passar o
              Reveillon mediante pagamento do valor.
            </p>
            <p>
              Esse exemplo só traz 3 possibilidades, mas poderiam ser 4, 5 ou
              até mais situações que combinadas poderiam trazer a devida
              efetividade nas transações.
            </p>
            <p>
              Além disso, acredita-se que a maior segurança nas transações, a
              facilidade no uso da plataforma, o pouco tempo necessário para se
              dedicar a gestão de sua cota e o baixíssimo custo sejam atrativos
              para os mais diversos proprietários do Brasil fazendo com que
              aumente ainda mais a chance de transações serem efetuadas.
            </p>
          </H3>
          <H2>Como poupamos tempo do proprietário?</H2>
          <H2>Como poupamos tempo do proprietário?</H2>
          <H3>
            <p>
              Como dito anteriormente, o tempo de cadastro das informações na
              plataforma é simples e rápido.
            </p>
            <p>
              Além disso, o proprietário não precisará ficar frequentando os
              mais diversos grupos de rede sociais para fazer transações ou
              responder perguntas, tampouco administrar anúncios.
            </p>
            <p>
              Para alguns empreendimentos que possuem um cronograma fixo,
              inserimos, também, os períodos de uso, o que facilita, e muito,
              pois os proprietários não precisarão procurar o documento do
              cronograma ou tentar lembrar qual período é o seu.
            </p>
            <p>
              Aliás, não são poucos os casos de proprietários que perderam seus
              períodos por não terem se atentado que esses já tinham passado ou
              estavam muito pertos.
            </p>
            <p>
              Em um futuro não distante, a plataforma também avisará ao
              proprietário, com antecedência razoável, quando um período estiver
              prestes a vencer.
            </p>
          </H3>
          <H2>Qual o custo para os proprietários? </H2>

          <H3>
            <p>Como dito anteriormente, o cadastro é gratuito. </p>
            <p>
              As transações de aluguel são gratuitas para o proprietário. É
              cobrado uma comissão de 15% mais taxas do montante do aluguel ao
              locatário (aquele que oferece um valor por um período em
              determinado empreendimento).
            </p>
            <p>
              Nas trocas é cobrado uma taxa fixa de R$ 95,00 dos proprietários
              por troca.
            </p>
          </H3>
        </TextWrapper>
      </ContainerTermo>
    </Container>
  );
}
